import type { FC } from "react"

import { studioToScreen } from "@logic/lib/design"
import type { Edge2dComputed } from "@logic/lib/mesh"
import type { RecoilValueReadOnly } from "recoil"
import { useRecoilValue } from "recoil"

import { zoomState } from "~/containers/LegacyDesigner/state/view"
import { getRainbow } from "~/utils/getRainbow"

export const RainbowEdgeGroup: FC<{
  edges: Edge2dComputed[]
  playbackPosition?: [number, number]
  color: string
  r: number
  i: number
}> = ({ edges, color, r, i, playbackPosition }) => {
  const zoom = useRecoilValue(zoomState)

  return (
    <g key={JSON.stringify(r)}>
      {edges.map(({ p1, p2 }, j) => {
        // const point2 = wrapInto(j + 1, points)
        const screenPoint1 = studioToScreen.point(p1, zoom)
        const screenPoint2 = studioToScreen.point(p2, zoom)
        const opacity = playbackPosition
          ? calculateOpacity([i, j], playbackPosition)
          : 1

        return (
          <line
            className="linked-edge"
            key={JSON.stringify(p1) + j}
            x1={screenPoint1.x}
            y1={screenPoint1.y}
            x2={screenPoint2.x}
            y2={screenPoint2.y}
            stroke={color}
            strokeWidth={r}
            opacity={opacity}
            strokeLinecap="round"
          />
        )
      })}
    </g>
  )
}

const calculateOpacity = (
  specimen: [number, number],
  position: [number, number],
): number =>
  specimen[0] !== position[0]
    ? 0.1
    : specimen[1] < position[1]
      ? 0.1
      : specimen[1] === position[1]
        ? 1
        : 0.1

export const RainbowEdgeGroups: FC<{
  edgeGroups: Edge2dComputed[][]
  playbackPosition: [number, number]
  offsetColor?: number
}> = ({ edgeGroups, playbackPosition, offsetColor }) => {
  return (
    <>
      {edgeGroups.map((edges, i, { length }) => {
        const color = getRainbow(i + (offsetColor ?? 0))
        const r = (length - i + 1) * 3

        return (
          <RainbowEdgeGroup
            key={JSON.stringify(r) + i}
            edges={edges}
            color={color}
            r={r}
            i={i}
            playbackPosition={playbackPosition}
          />
        )
      })}
    </>
  )
}
